import React, { useState } from 'react';
import { Offcanvas } from "react-bootstrap";
import { Stepper } from 'react-form-stepper';
import { Form } from 'react-bootstrap';
import StepOne from './create/StepOne';
import StepTwo from './create/StepTwo';
import StepThree from './create/StepThree';
import StepFour from './create/StepFour';
import StepFive from './create/StepFive';
import StepSix from './create/StepSix';
import StepSeven from './create/StepSeven';
import StepEight from './create/StepEight';
import StepNine from './create/StepNine';
import StepTen from './create/StepTen';
import { useNavigate } from 'react-router-dom';

const CreateApplication = () => {
    const navigation = useNavigate();
   
    const [activeStep, setActiveStep] = useState(0);
    const stepForm = [
        {
            id: 1,
            component: (
                <StepOne activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <StepTwo activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 3,
            component: (
                <StepThree activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 4,
            component: (
                <StepFour activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 5,
            component: (
                <StepFive activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 6,
            component: (
                <StepSix activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 7,
            component: (
                <StepSeven activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 8,
            component: (
                <StepEight activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 9,
            component: (
                <StepNine activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 10,
            component: (
                <StepTen activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            <div className="canvas-lg bg-light py-5" placement="end">

                <div className="top-bar text-center">
                    <Offcanvas.Title>
                        Driver Application
                    </Offcanvas.Title>
                </div>

                <Offcanvas.Body>
                    <Stepper
                        steps={[
                            { label: 'Personal Information'},
                            { label: 'Driver’s License Information'},
                            { label: 'Drug Test Information'},
                            { label: 'Pre-Employment Information'},
                            { label: 'Social Security Information'},
                            { label: '(MVR)'},
                            { label: 'Consent & Legal Agreements'},
                            { label: 'Optional Uploads'},
                            { label: 'Emergency Contact'},
                            { label: 'DOT Physical Exam'}]}
                        styleConfig={{
                            activeBgColor: "green",
                            activeTextColor: "#fff",
                            inactiveBgColor: "#fff",
                            inactiveTextColor: "#999",
                            completedBgColor: "#201f43",
                            completedTextColor: "#fff",
                            size: "2em",
                        }}
                        activeStep={activeStep}
                    />
                    {stepForm[activeStep].component}
                  
                </Offcanvas.Body>
            </div>
        </>
    );
};

export default CreateApplication;